document.addEventListener("DOMContentLoaded", () => {

    const legend =
        document.getElementById("zaeth-legend");

    if (!legend) return;


    /*
     * ==========================================
     * SHOW LEGEND ONLY ONCE PER SESSION
     * ==========================================
     */

    if (
        sessionStorage.getItem(
            "zaethLegendSeen"
        ) === "true"
    ) {

        legend.style.display = "none";
        legend.remove();

        document.body.classList.remove(
            "zaeth-legend-open"
        );

        return;
    }


    /*
     * ==========================================
     * ELEMENTS
     * ==========================================
     */

    const logo =
        document.querySelector(".zl-logo");

    const tagline =
        document.querySelector(".zl-tagline");

    const enter =
        document.querySelector(".zl-enter");

    const intro =
        document.querySelector(".zl-intro");

    const worlds =
        document.querySelector(".zl-worlds");

    const world =
        document.querySelectorAll(".zl-world");

    const center =
        document.querySelector(".zl-center");


    let locked = false;


    /*
     * ==========================================
     * LOCK PAGE WHILE LEGEND IS ACTIVE
     * ==========================================
     */

    document.body.classList.add(
        "zaeth-legend-open"
    );


    /*
     * ==========================================
     * INTRO ANIMATION
     * ==========================================
     */

    setTimeout(() => {

        if (logo) {
            logo.classList.add(
                "show-logo"
            );
        }

    }, 700);


    setTimeout(() => {

        if (tagline) {
            tagline.classList.add(
                "show-tagline"
            );
        }

    }, 1700);


    setTimeout(() => {

        if (logo) {
            logo.classList.add(
                "hide-intro"
            );
        }

        if (tagline) {
            tagline.classList.add(
                "hide-intro"
            );
        }

    }, 4300);


    setTimeout(() => {

        if (!center) return;


        center.classList.add(
            "page-one-hide"
        );


        setTimeout(() => {

            center.classList.add(
                "show-page-two"
            );


            setTimeout(() => {

                if (enter) {

                    enter.classList.add(
                        "show-enter"
                    );

                }

            }, 450);

        }, 800);

    }, 5600);


    /*
     * ==========================================
     * ENTER BUTTON
     * ==========================================
     */

    if (enter) {

        enter.addEventListener(
            "click",
            () => {

                enter.classList.add(
                    "clicked"
                );

                enter.style.pointerEvents =
                    "none";


                setTimeout(() => {

                    if (intro) {

                        intro.style.opacity =
                            "0";

                        intro.style.pointerEvents =
                            "none";

                    }

                }, 150);


                if (worlds) {

                    worlds.classList.add(
                        "ready"
                    );

                }


                setTimeout(() => {

                    if (intro) {

                        intro.style.visibility =
                            "hidden";

                    }

                }, 250);

            },
            {
                passive: true
            }
        );

    }


    /*
     * ==========================================
     * WORLD SELECTION
     * ==========================================
     *
     * IMPORTANT:
     * This is the original working navigation.
     * DO NOT replace with AJAX.
     * ==========================================
     */

    world.forEach(
        card => {

            card.addEventListener(
                "click",
                () => {

                    if (locked) return;

                    locked = true;


                    /*
                     * SAVE WORLD
                     */

                    if (
                        card.classList.contains(
                            "core"
                        )
                    ) {

                        localStorage.setItem(
                            "zaeth-world",
                            "core"
                        );

                    } else {

                        localStorage.setItem(
                            "zaeth-world",
                            "essential"
                        );

                    }


                    /*
                     * FADE OTHER WORLD
                     */

                    world.forEach(
                        item => {

                            if (
                                item !== card
                            ) {

                                item.classList.add(
                                    "fade-out"
                                );

                            }

                        }
                    );


                    /*
                     * EXPAND SELECTED WORLD
                     */

                    card.classList.add(
                        "expanding"
                    );


                    /*
                     * HIDE LEGEND
                     */

                    setTimeout(() => {

                        legend.classList.add(
                            "hide"
                        );

                    }, 1700);


                    /*
                     * NORMAL SHOPIFY NAVIGATION
                     */

                    setTimeout(() => {

                        sessionStorage.setItem(
                            "zaethLegendSeen",
                            "true"
                        );


                        document.body.classList.remove(
                            "zaeth-legend-open"
                        );


                        window.location.replace(
                            card.dataset.url
                        );

                    }, 600);

                },
                {
                    passive: true
                }
            );

        }
    );

});